import { observer } from 'mobx-react';
import { FormEvent, useCallback, useMemo, useState } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { localeStore } from 'src/mobx/localesStore';
import Input from 'src/view/components/Controls/Input/Input';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';
import { appStore } from '~/mobx/appStore';

const CheckoutPromocode: React.FC = observer((): JSX.Element | null => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const [promocode, setPromocode] = useState<string>(checkoutStore.calculator.promocode || checkoutStore.params.promocode);

  const onFormSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (!(checkoutStore.calculator.promocode || checkoutStore.params.promocode || promocode)) return;
      checkoutStore.changePromocode(promocode);
    },
    [promocode, checkoutStore.calculator.promocode, checkoutStore.params.promocode]
  );

  const onClearPromocode = useCallback(() => {
    setPromocode('');
    checkoutStore.changePromocode('');
  }, []);

  const errorPromo = useMemo((): string | null => {
    return checkoutStore.calculator.discount_error?.error_promo || null;
  }, [checkoutStore.calculator.discount_error]);

  const promocodeClassName = useMemo((): string => {
    let className: string = 'checkout-promocode';

    if (errorPromo) className += ' input-error';

    return className;
  }, [errorPromo]);

  if (Boolean(checkoutStore.params.use_wallet)) {
    return null;
  }

  return (
    <div className="d-flex flex-1">
      <form onSubmit={onFormSubmit} className="d-flex flex-column flex-1">
        <div className={promocodeClassName}>
          {/* input */}
          <Input
            id="promocode-input"
            withResetIcon
            // disabled={disabled}
            value={promocode}
            onChangeText={(_promocode) => setPromocode(_promocode)}
            onReset={onClearPromocode}
            placeholder={localeStore.t('cc_promo_and_coupon_placeholder')}
            className="checkout-promocode-input input-mini"
            wrapperClassName="checkout-promocode-input-wrapper"
          />
          {/* submit button */}
          <button type="submit" className="checkout-promocode-button">
            {localeStore.t('apply')}
          </button>
        </div>
        {checkoutStore.calculator.promocode && !checkoutStore.calculator.cashback.amount && appStore.settings?.cashback ? (
          <Text text="cashback_with_promo" type="custom" className="text-size-14 color-gray2 pt-2" />
        ) : null}
        {checkoutStore.calculator.promocode && !!checkoutStore.calculator.cashback.amount ? (
          <Text text="promocode_activated_cashback_with_offer" type="custom" className="text-size-14 color-gray2 pt-2" />
        ) : null}
        {/* error text */}
        {errorPromo ? <Text type={TEXT.ERROR} text={errorPromo} noTranslate className="mt-2" /> : null}
      </form>
    </div>
  );
});

export default CheckoutPromocode;
